import {
  nullIfZero2w6gbitjuuknl as nullIfZero,
  ApiVersion_FEBRUARY_2026_getInstancexhgc3m6uvy4r as ApiVersion_FEBRUARY_2026_getInstance,
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  ApiPaginatedResponse21k9qwv83e5dh as ApiPaginatedResponse,
  NetworkJobManager330ytw7ckzld9 as NetworkJobManager,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  LazyThreadSafetyMode_PUBLICATION_getInstance2x9bac6dffafm as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Unit_instance104q5opgivhr8 as Unit_instance,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  equals2au1ep9vhcato as equals,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Result3t1vadv16kmzk as Result,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  Unitkvevlwgzwiuc as Unit,
  getValue48kllevslyh6 as getValue,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  _Result___get_isFailure__impl__jpirivzehaw445b0cy as _Result___get_isFailure__impl__jpiriv,
  emptyList1g2z5xcrvp2zy as emptyList,
  Long2qws0ah9gnpki as Long,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  IntSerializer_getInstance9scrtcljaiv6 as IntSerializer_getInstance,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  get_nullable197rfua9r7fsz as get_nullable,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  BooleanSerializer_getInstancet3wtk7fl7i4f as BooleanSerializer_getInstance,
  createAnnotatedEnumSerializer20ay4pme9p2h9 as createAnnotatedEnumSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  SimpleValueEndpointCacheStrategy2snxed6lorji8 as SimpleValueEndpointCacheStrategy,
  QueryListEndpointCacheStrategy1c0c59lgyft8l as QueryListEndpointCacheStrategy,
  Companion_instance38at02i5wbrbj as Companion_instance_0,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  Unknown1xcq5nwq6ckcn as Unknown,
  ILocalSource1zuymxsgjvvss as ILocalSource,
  SimpleCacheLocalSource3mbicvk11uh40 as SimpleCacheLocalSource,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  IListLocalSource39ga4nlfbxuv1 as IListLocalSource,
  SimpleListCacheLocalSource9ig3nhg8ocnr as SimpleListCacheLocalSource,
} from './Shared7Punches-common-base.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import { Companion_getInstancepumzx9q4106p as Companion_getInstance_0 } from './ktor-ktor-http.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  Companion_getInstance1rlvzabi952im as Companion_getInstance_1,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
import { PollingServiceRegistry1wltrmn5ft1vf as PollingServiceRegistry } from './Shared7Punches-infrastructure-polling.mjs';
import { Mutex16li1l0asjv17 as Mutex } from './kotlinx-coroutines-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiAIImporterStatus, 'ApiAIImporterStatus', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiDiscoverPayrollMenuItemData, 'ApiDiscoverPayrollMenuItemData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiDiscoverPayrollMenuItemContent, 'ApiDiscoverPayrollMenuItemContent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForCompanion(Companion_1);
initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiEarnedWageAccessDiscoveryData, 'ApiEarnedWageAccessDiscoveryData', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
initMetadataForCompanion(Companion_2);
initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiKnockToJoinSignup, 'ApiKnockToJoinSignup', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
initMetadataForCompanion(Companion_3, VOID, [SerializerFactory]);
initMetadataForClass(ApiShiftExtractionStatus, 'ApiShiftExtractionStatus', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_6});
initMetadataForFunctionReference(ILocalSource$put$ref, VOID, VOID, [1]);
initMetadataForLambda(AIImporterRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [0]);
initMetadataForInterface(IAIImporterAccessor, 'IAIImporterAccessor');
initMetadataForInterface(IAIImporterMutator, 'IAIImporterMutator', VOID, VOID, VOID, [1, 2]);
initMetadataForClass(AIImporterRepository, 'AIImporterRepository', VOID, VOID, [IAIImporterAccessor, IAIImporterMutator], [1, 2]);
initMetadataForInterface(IAccountActivationRepository, 'IAccountActivationRepository', VOID, VOID, VOID, [0]);
initMetadataForClass(AccountActivationRepository, 'AccountActivationRepository', VOID, VOID, [IAccountActivationRepository], [0]);
initMetadataForFunctionReference(ILocalSource$put$ref_1, VOID, VOID, [1]);
initMetadataForLambda(EarnedWageAccessDiscoveryRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [0]);
initMetadataForInterface(IEarnedWageAccessDiscoveryAccessor, 'IEarnedWageAccessDiscoveryAccessor');
initMetadataForInterface(IEarnedWageAccessDiscoveryMutator, 'IEarnedWageAccessDiscoveryMutator', VOID, VOID, VOID, [0]);
initMetadataForClass(EarnedWageAccessDiscoveryRepository, 'EarnedWageAccessDiscoveryRepository', VOID, VOID, [IEarnedWageAccessDiscoveryAccessor, IEarnedWageAccessDiscoveryMutator], [0]);
initMetadataForLambda(KnockToJoinRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [2]);
initMetadataForLambda(KnockToJoinRepository$cacheStrategy$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForInterface(IKnockToJoinAccessor, 'IKnockToJoinAccessor');
initMetadataForInterface(IKnockToJoinMutator, 'IKnockToJoinMutator', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(KnockToJoinRepository, 'KnockToJoinRepository', VOID, VOID, [IKnockToJoinAccessor, IKnockToJoinMutator], [2, 1]);
initMetadataForInterface(IAIImporterRemoteSource, 'IAIImporterRemoteSource', VOID, VOID, VOID, [0, 1, 2]);
initMetadataForCompanion(Companion_4);
initMetadataForCoroutine($getCOROUTINE$6, CoroutineImpl);
initMetadataForCoroutine($basePathCOROUTINE$9, CoroutineImpl);
initMetadataForClass(AIImporterRemoteSource, 'AIImporterRemoteSource', VOID, VOID, [IAIImporterRemoteSource], [0, 1, 2]);
initMetadataForInterface(IAccountActivationRemoteSource, 'IAccountActivationRemoteSource', VOID, VOID, VOID, [1]);
initMetadataForClass(AccountActivationRemoteSource, 'AccountActivationRemoteSource', VOID, VOID, [IAccountActivationRemoteSource], [1]);
initMetadataForInterface(IEarnedWageAccessDiscoveryRemoteSource, 'IEarnedWageAccessDiscoveryRemoteSource', VOID, VOID, VOID, [0]);
initMetadataForCoroutine($fetchCOROUTINE$11, CoroutineImpl);
initMetadataForClass(EarnedWageAccessDiscoveryRemoteSource, 'EarnedWageAccessDiscoveryRemoteSource', VOID, VOID, [IEarnedWageAccessDiscoveryRemoteSource], [0]);
initMetadataForInterface(IKnockToJoinRemoteSource, 'IKnockToJoinRemoteSource', VOID, VOID, VOID, [1, 2]);
initMetadataForCompanion(Companion_5);
initMetadataForLambda(KnockToJoinRemoteSource$list$slambda, CoroutineImpl, VOID, [0]);
initMetadataForCoroutine($basePathCOROUTINE$15, CoroutineImpl);
initMetadataForClass(KnockToJoinRemoteSource, 'KnockToJoinRemoteSource', VOID, VOID, [IKnockToJoinRemoteSource], [1, 2, 0]);
initMetadataForClass(AIImporterStatus, 'AIImporterStatus');
initMetadataForClass(EarnedWageAccessDiscovery, 'EarnedWageAccessDiscovery');
initMetadataForClass(KnockToJoinSignup, 'KnockToJoinSignup');
initMetadataForClass(KnockToJoinSignupStatus, 'KnockToJoinSignupStatus', VOID, Enum);
initMetadataForClass(ShiftExtractionStatus, 'ShiftExtractionStatus', VOID, Enum);
initMetadataForInterface(IRefreshAIImporterExtractionStatusUseCase, 'IRefreshAIImporterExtractionStatusUseCase', VOID, VOID, VOID, [0]);
initMetadataForClass(RefreshAIImporterExtractionStatusUseCase, 'RefreshAIImporterExtractionStatusUseCase', VOID, VOID, [IRefreshAIImporterExtractionStatusUseCase], [0, 1]);
//endregion
function toDomain(_this__u8e3s4) {
  var tmp = toDomain_0(_this__u8e3s4.i6w_1);
  var tmp0_elvis_lhs = _this__u8e3s4.k6w_1;
  return new AIImporterStatus(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, nullIfZero(_this__u8e3s4.j6w_1), !(_this__u8e3s4.l6w_1 == null));
}
function toDomain_0(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.l2_1) {
    case 0:
      tmp = ShiftExtractionStatus_NOT_STARTED_getInstance();
      break;
    case 1:
      tmp = ShiftExtractionStatus_RUNNING_getInstance();
      break;
    case 2:
      tmp = ShiftExtractionStatus_COMPLETED_getInstance();
      break;
    case 3:
      tmp = ShiftExtractionStatus_SKIPPED_getInstance();
      break;
    case 4:
      tmp = ShiftExtractionStatus_FAILED_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toDomain_1(_this__u8e3s4) {
  return new EarnedWageAccessDiscovery(_this__u8e3s4.m6w_1);
}
function toApi(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.l2_1 === 0) {
    tmp = 'pending_approval';
  } else {
    noWhenBranchMatchedException();
  }
  return tmp;
}
function toDomain_2(_this__u8e3s4) {
  return new KnockToJoinSignup(_this__u8e3s4.n6w_1, _this__u8e3s4.o6w_1, _this__u8e3s4.p6w_1, _this__u8e3s4.q6w_1, _this__u8e3s4.r6w_1, _this__u8e3s4.s6w_1);
}
function ApiAIImporterStatus$Companion$$childSerializers$_anonymous__erfxg() {
  return Companion_getInstance_6().v61();
}
function Companion() {
  Companion_instance_1 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.u6w_1 = [lazy(tmp_0, ApiAIImporterStatus$Companion$$childSerializers$_anonymous__erfxg), null, null, null];
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 == null)
    new Companion();
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.accountactivation.data.models.ApiAIImporterStatus', this, 4);
  tmp0_serialDesc.wy('shift_extraction_status', false);
  tmp0_serialDesc.wy('workflow_run_id', false);
  tmp0_serialDesc.wy('extracted_shifts_count', false);
  tmp0_serialDesc.wy('apply_extracted_shifts_prompt_dismissed', false);
  this.v6w_1 = tmp0_serialDesc;
}
protoOf($serializer).w6w = function (encoder, value) {
  var tmp0_desc = this.v6w_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance_2().u6w_1;
  tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0].t(), value.i6w_1);
  tmp1_output.dt(tmp0_desc, 1, IntSerializer_getInstance(), value.j6w_1);
  tmp1_output.dt(tmp0_desc, 2, IntSerializer_getInstance(), value.k6w_1);
  tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.l6w_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.w6w(encoder, value instanceof ApiAIImporterStatus ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.v6w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.kr(tmp0_desc);
  var tmp9_cached = Companion_getInstance_2().u6w_1;
  if (tmp8_input.as()) {
    tmp4_local0 = tmp8_input.wr(tmp0_desc, 0, tmp9_cached[0].t(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.yr(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.yr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.yr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.wr(tmp0_desc, 0, tmp9_cached[0].t(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.yr(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.yr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.yr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.lr(tmp0_desc);
  return ApiAIImporterStatus_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer).xn = function () {
  return this.v6w_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [Companion_getInstance_2().u6w_1[0].t(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiAIImporterStatus_init_$Init$(seen0, shiftExtractionStatus, workflowRunId, extractedShiftsCount, applyExtractedShiftsPromptDismissed, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance().v6w_1);
  }
  $this.i6w_1 = shiftExtractionStatus;
  $this.j6w_1 = workflowRunId;
  $this.k6w_1 = extractedShiftsCount;
  $this.l6w_1 = applyExtractedShiftsPromptDismissed;
  return $this;
}
function ApiAIImporterStatus_init_$Create$(seen0, shiftExtractionStatus, workflowRunId, extractedShiftsCount, applyExtractedShiftsPromptDismissed, serializationConstructorMarker) {
  return ApiAIImporterStatus_init_$Init$(seen0, shiftExtractionStatus, workflowRunId, extractedShiftsCount, applyExtractedShiftsPromptDismissed, serializationConstructorMarker, objectCreate(protoOf(ApiAIImporterStatus)));
}
function ApiAIImporterStatus(shiftExtractionStatus, workflowRunId, extractedShiftsCount, applyExtractedShiftsPromptDismissed) {
  Companion_getInstance_2();
  this.i6w_1 = shiftExtractionStatus;
  this.j6w_1 = workflowRunId;
  this.k6w_1 = extractedShiftsCount;
  this.l6w_1 = applyExtractedShiftsPromptDismissed;
}
protoOf(ApiAIImporterStatus).toString = function () {
  return 'ApiAIImporterStatus(shiftExtractionStatus=' + this.i6w_1.toString() + ', workflowRunId=' + this.j6w_1 + ', extractedShiftsCount=' + this.k6w_1 + ', applyExtractedShiftsPromptDismissed=' + this.l6w_1 + ')';
};
protoOf(ApiAIImporterStatus).hashCode = function () {
  var result = this.i6w_1.hashCode();
  result = imul(result, 31) + (this.j6w_1 == null ? 0 : this.j6w_1) | 0;
  result = imul(result, 31) + (this.k6w_1 == null ? 0 : this.k6w_1) | 0;
  result = imul(result, 31) + (this.l6w_1 == null ? 0 : getStringHashCode(this.l6w_1)) | 0;
  return result;
};
protoOf(ApiAIImporterStatus).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiAIImporterStatus))
    return false;
  var tmp0_other_with_cast = other instanceof ApiAIImporterStatus ? other : THROW_CCE();
  if (!this.i6w_1.equals(tmp0_other_with_cast.i6w_1))
    return false;
  if (!(this.j6w_1 == tmp0_other_with_cast.j6w_1))
    return false;
  if (!(this.k6w_1 == tmp0_other_with_cast.k6w_1))
    return false;
  if (!(this.l6w_1 == tmp0_other_with_cast.l6w_1))
    return false;
  return true;
};
function Companion_0() {
}
var Companion_instance_2;
function Companion_getInstance_3() {
  return Companion_instance_2;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.accountactivation.data.models.ApiDiscoverPayrollMenuItemData', this, 1);
  tmp0_serialDesc.wy('content', false);
  this.x6w_1 = tmp0_serialDesc;
}
protoOf($serializer_0).y6w = function (encoder, value) {
  var tmp0_desc = this.x6w_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.dt(tmp0_desc, 0, $serializer_getInstance_1(), value.z6w_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_0).yn = function (encoder, value) {
  return this.y6w(encoder, value instanceof ApiDiscoverPayrollMenuItemData ? value : THROW_CCE());
};
protoOf($serializer_0).zn = function (decoder) {
  var tmp0_desc = this.x6w_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.yr(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.yr(tmp0_desc, 0, $serializer_getInstance_1(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiDiscoverPayrollMenuItemData_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_0).xn = function () {
  return this.x6w_1;
};
protoOf($serializer_0).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable($serializer_getInstance_1())];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function ApiDiscoverPayrollMenuItemData_init_$Init$(seen0, content, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_0().x6w_1);
  }
  $this.z6w_1 = content;
  return $this;
}
function ApiDiscoverPayrollMenuItemData_init_$Create$(seen0, content, serializationConstructorMarker) {
  return ApiDiscoverPayrollMenuItemData_init_$Init$(seen0, content, serializationConstructorMarker, objectCreate(protoOf(ApiDiscoverPayrollMenuItemData)));
}
function ApiDiscoverPayrollMenuItemData(content) {
  this.z6w_1 = content;
}
protoOf(ApiDiscoverPayrollMenuItemData).toString = function () {
  return 'ApiDiscoverPayrollMenuItemData(content=' + toString(this.z6w_1) + ')';
};
protoOf(ApiDiscoverPayrollMenuItemData).hashCode = function () {
  return this.z6w_1 == null ? 0 : this.z6w_1.hashCode();
};
protoOf(ApiDiscoverPayrollMenuItemData).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiDiscoverPayrollMenuItemData))
    return false;
  var tmp0_other_with_cast = other instanceof ApiDiscoverPayrollMenuItemData ? other : THROW_CCE();
  if (!equals(this.z6w_1, tmp0_other_with_cast.z6w_1))
    return false;
  return true;
};
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.accountactivation.data.models.ApiDiscoverPayrollMenuItemContent', this, 1);
  tmp0_serialDesc.wy('offer', false);
  this.a6x_1 = tmp0_serialDesc;
}
protoOf($serializer_1).b6x = function (encoder, value) {
  var tmp0_desc = this.a6x_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.c6x_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_1).yn = function (encoder, value) {
  return this.b6x(encoder, value instanceof ApiDiscoverPayrollMenuItemContent ? value : THROW_CCE());
};
protoOf($serializer_1).zn = function (decoder) {
  var tmp0_desc = this.a6x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.yr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.yr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiDiscoverPayrollMenuItemContent_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_1).xn = function () {
  return this.a6x_1;
};
protoOf($serializer_1).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function ApiDiscoverPayrollMenuItemContent_init_$Init$(seen0, offer, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_1().a6x_1);
  }
  $this.c6x_1 = offer;
  return $this;
}
function ApiDiscoverPayrollMenuItemContent_init_$Create$(seen0, offer, serializationConstructorMarker) {
  return ApiDiscoverPayrollMenuItemContent_init_$Init$(seen0, offer, serializationConstructorMarker, objectCreate(protoOf(ApiDiscoverPayrollMenuItemContent)));
}
function ApiDiscoverPayrollMenuItemContent() {
}
protoOf(ApiDiscoverPayrollMenuItemContent).toString = function () {
  return 'ApiDiscoverPayrollMenuItemContent(offer=' + this.c6x_1 + ')';
};
protoOf(ApiDiscoverPayrollMenuItemContent).hashCode = function () {
  return this.c6x_1 == null ? 0 : getStringHashCode(this.c6x_1);
};
protoOf(ApiDiscoverPayrollMenuItemContent).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiDiscoverPayrollMenuItemContent))
    return false;
  var tmp0_other_with_cast = other instanceof ApiDiscoverPayrollMenuItemContent ? other : THROW_CCE();
  if (!(this.c6x_1 == tmp0_other_with_cast.c6x_1))
    return false;
  return true;
};
function Companion_1() {
}
var Companion_instance_3;
function Companion_getInstance_4() {
  return Companion_instance_3;
}
function $serializer_2() {
  $serializer_instance_2 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.accountactivation.data.models.ApiEarnedWageAccessDiscoveryData', this, 1);
  tmp0_serialDesc.wy('should_show_prompt', false);
  this.d6x_1 = tmp0_serialDesc;
}
protoOf($serializer_2).e6x = function (encoder, value) {
  var tmp0_desc = this.d6x_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.rs(tmp0_desc, 0, value.m6w_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_2).yn = function (encoder, value) {
  return this.e6x(encoder, value instanceof ApiEarnedWageAccessDiscoveryData ? value : THROW_CCE());
};
protoOf($serializer_2).zn = function (decoder) {
  var tmp0_desc = this.d6x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = false;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.mr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.mr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiEarnedWageAccessDiscoveryData_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_2).xn = function () {
  return this.d6x_1;
};
protoOf($serializer_2).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [BooleanSerializer_getInstance()];
};
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 == null)
    new $serializer_2();
  return $serializer_instance_2;
}
function ApiEarnedWageAccessDiscoveryData_init_$Init$(seen0, shouldShowPrompt, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance_2().d6x_1);
  }
  $this.m6w_1 = shouldShowPrompt;
  return $this;
}
function ApiEarnedWageAccessDiscoveryData_init_$Create$(seen0, shouldShowPrompt, serializationConstructorMarker) {
  return ApiEarnedWageAccessDiscoveryData_init_$Init$(seen0, shouldShowPrompt, serializationConstructorMarker, objectCreate(protoOf(ApiEarnedWageAccessDiscoveryData)));
}
function ApiEarnedWageAccessDiscoveryData(shouldShowPrompt) {
  this.m6w_1 = shouldShowPrompt;
}
protoOf(ApiEarnedWageAccessDiscoveryData).toString = function () {
  return 'ApiEarnedWageAccessDiscoveryData(shouldShowPrompt=' + this.m6w_1 + ')';
};
protoOf(ApiEarnedWageAccessDiscoveryData).hashCode = function () {
  return getBooleanHashCode(this.m6w_1);
};
protoOf(ApiEarnedWageAccessDiscoveryData).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiEarnedWageAccessDiscoveryData))
    return false;
  var tmp0_other_with_cast = other instanceof ApiEarnedWageAccessDiscoveryData ? other : THROW_CCE();
  if (!(this.m6w_1 === tmp0_other_with_cast.m6w_1))
    return false;
  return true;
};
function Companion_2() {
}
var Companion_instance_4;
function Companion_getInstance_5() {
  return Companion_instance_4;
}
function $serializer_3() {
  $serializer_instance_3 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.accountactivation.data.models.ApiKnockToJoinSignup', this, 6);
  tmp0_serialDesc.wy('uuid', false);
  tmp0_serialDesc.wy('email', false);
  tmp0_serialDesc.wy('first_name', false);
  tmp0_serialDesc.wy('last_name', false);
  tmp0_serialDesc.wy('expires_soon', false);
  tmp0_serialDesc.wy('days_until_expiry', false);
  this.f6x_1 = tmp0_serialDesc;
}
protoOf($serializer_3).g6x = function (encoder, value) {
  var tmp0_desc = this.f6x_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.zs(tmp0_desc, 0, value.n6w_1);
  tmp1_output.zs(tmp0_desc, 1, value.o6w_1);
  tmp1_output.zs(tmp0_desc, 2, value.p6w_1);
  tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.q6w_1);
  tmp1_output.rs(tmp0_desc, 4, value.r6w_1);
  tmp1_output.us(tmp0_desc, 5, value.s6w_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_3).yn = function (encoder, value) {
  return this.g6x(encoder, value instanceof ApiKnockToJoinSignup ? value : THROW_CCE());
};
protoOf($serializer_3).zn = function (decoder) {
  var tmp0_desc = this.f6x_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_local4 = false;
  var tmp9_local5 = 0;
  var tmp10_input = decoder.kr(tmp0_desc);
  if (tmp10_input.as()) {
    tmp4_local0 = tmp10_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp10_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp10_input.ur(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp10_input.yr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp10_input.mr(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp10_input.pr(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp10_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp10_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp10_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp10_input.ur(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp10_input.yr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp10_input.mr(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp10_input.pr(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp10_input.lr(tmp0_desc);
  return ApiKnockToJoinSignup_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
};
protoOf($serializer_3).xn = function () {
  return this.f6x_1;
};
protoOf($serializer_3).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), IntSerializer_getInstance()];
};
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 == null)
    new $serializer_3();
  return $serializer_instance_3;
}
function ApiKnockToJoinSignup_init_$Init$(seen0, uuid, email, firstName, lastName, expiresSoon, daysUntilExpiry, serializationConstructorMarker, $this) {
  if (!(63 === (63 & seen0))) {
    throwMissingFieldException(seen0, 63, $serializer_getInstance_3().f6x_1);
  }
  $this.n6w_1 = uuid;
  $this.o6w_1 = email;
  $this.p6w_1 = firstName;
  $this.q6w_1 = lastName;
  $this.r6w_1 = expiresSoon;
  $this.s6w_1 = daysUntilExpiry;
  return $this;
}
function ApiKnockToJoinSignup_init_$Create$(seen0, uuid, email, firstName, lastName, expiresSoon, daysUntilExpiry, serializationConstructorMarker) {
  return ApiKnockToJoinSignup_init_$Init$(seen0, uuid, email, firstName, lastName, expiresSoon, daysUntilExpiry, serializationConstructorMarker, objectCreate(protoOf(ApiKnockToJoinSignup)));
}
function ApiKnockToJoinSignup(uuid, email, firstName, lastName, expiresSoon, daysUntilExpiry) {
  this.n6w_1 = uuid;
  this.o6w_1 = email;
  this.p6w_1 = firstName;
  this.q6w_1 = lastName;
  this.r6w_1 = expiresSoon;
  this.s6w_1 = daysUntilExpiry;
}
protoOf(ApiKnockToJoinSignup).toString = function () {
  return 'ApiKnockToJoinSignup(uuid=' + this.n6w_1 + ', email=' + this.o6w_1 + ', firstName=' + this.p6w_1 + ', lastName=' + this.q6w_1 + ', expiresSoon=' + this.r6w_1 + ', daysUntilExpiry=' + this.s6w_1 + ')';
};
protoOf(ApiKnockToJoinSignup).hashCode = function () {
  var result = getStringHashCode(this.n6w_1);
  result = imul(result, 31) + getStringHashCode(this.o6w_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.p6w_1) | 0;
  result = imul(result, 31) + (this.q6w_1 == null ? 0 : getStringHashCode(this.q6w_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.r6w_1) | 0;
  result = imul(result, 31) + this.s6w_1 | 0;
  return result;
};
protoOf(ApiKnockToJoinSignup).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiKnockToJoinSignup))
    return false;
  var tmp0_other_with_cast = other instanceof ApiKnockToJoinSignup ? other : THROW_CCE();
  if (!(this.n6w_1 === tmp0_other_with_cast.n6w_1))
    return false;
  if (!(this.o6w_1 === tmp0_other_with_cast.o6w_1))
    return false;
  if (!(this.p6w_1 === tmp0_other_with_cast.p6w_1))
    return false;
  if (!(this.q6w_1 == tmp0_other_with_cast.q6w_1))
    return false;
  if (!(this.r6w_1 === tmp0_other_with_cast.r6w_1))
    return false;
  if (!(this.s6w_1 === tmp0_other_with_cast.s6w_1))
    return false;
  return true;
};
function _get_$cachedSerializer__te6jhj($this) {
  return $this.t6w_1.t();
}
function ApiShiftExtractionStatus$Companion$_anonymous__vyirji() {
  var tmp = values();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = ['not_started', 'running', 'completed', 'skipped', 'failed'];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [null, null, null, null, null];
  return createAnnotatedEnumSerializer('com.sevenshifts.shared.data.accountactivation.data.models.ApiShiftExtractionStatus', tmp, tmp_0, tmp$ret$5, null);
}
var ApiShiftExtractionStatus_NOT_STARTED_instance;
var ApiShiftExtractionStatus_RUNNING_instance;
var ApiShiftExtractionStatus_COMPLETED_instance;
var ApiShiftExtractionStatus_SKIPPED_instance;
var ApiShiftExtractionStatus_FAILED_instance;
function values() {
  return [ApiShiftExtractionStatus_NOT_STARTED_getInstance(), ApiShiftExtractionStatus_RUNNING_getInstance(), ApiShiftExtractionStatus_COMPLETED_getInstance(), ApiShiftExtractionStatus_SKIPPED_getInstance(), ApiShiftExtractionStatus_FAILED_getInstance()];
}
function Companion_3() {
  Companion_instance_5 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.t6w_1 = lazy(tmp_0, ApiShiftExtractionStatus$Companion$_anonymous__vyirji);
}
protoOf(Companion_3).v61 = function () {
  return _get_$cachedSerializer__te6jhj(this);
};
protoOf(Companion_3).a10 = function (typeParamsSerializers) {
  return this.v61();
};
var Companion_instance_5;
function Companion_getInstance_6() {
  ApiShiftExtractionStatus_initEntries();
  if (Companion_instance_5 == null)
    new Companion_3();
  return Companion_instance_5;
}
var ApiShiftExtractionStatus_entriesInitialized;
function ApiShiftExtractionStatus_initEntries() {
  if (ApiShiftExtractionStatus_entriesInitialized)
    return Unit_instance;
  ApiShiftExtractionStatus_entriesInitialized = true;
  ApiShiftExtractionStatus_NOT_STARTED_instance = new ApiShiftExtractionStatus('NOT_STARTED', 0);
  ApiShiftExtractionStatus_RUNNING_instance = new ApiShiftExtractionStatus('RUNNING', 1);
  ApiShiftExtractionStatus_COMPLETED_instance = new ApiShiftExtractionStatus('COMPLETED', 2);
  ApiShiftExtractionStatus_SKIPPED_instance = new ApiShiftExtractionStatus('SKIPPED', 3);
  ApiShiftExtractionStatus_FAILED_instance = new ApiShiftExtractionStatus('FAILED', 4);
  Companion_getInstance_6();
}
function ApiShiftExtractionStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ApiShiftExtractionStatus_NOT_STARTED_getInstance() {
  ApiShiftExtractionStatus_initEntries();
  return ApiShiftExtractionStatus_NOT_STARTED_instance;
}
function ApiShiftExtractionStatus_RUNNING_getInstance() {
  ApiShiftExtractionStatus_initEntries();
  return ApiShiftExtractionStatus_RUNNING_instance;
}
function ApiShiftExtractionStatus_COMPLETED_getInstance() {
  ApiShiftExtractionStatus_initEntries();
  return ApiShiftExtractionStatus_COMPLETED_instance;
}
function ApiShiftExtractionStatus_SKIPPED_getInstance() {
  ApiShiftExtractionStatus_initEntries();
  return ApiShiftExtractionStatus_SKIPPED_instance;
}
function ApiShiftExtractionStatus_FAILED_getInstance() {
  ApiShiftExtractionStatus_initEntries();
  return ApiShiftExtractionStatus_FAILED_instance;
}
function ILocalSource$put$ref($boundThis) {
  this.h6x_1 = $boundThis;
}
protoOf(ILocalSource$put$ref).i6x = function (p0, $completion) {
  return this.h6x_1.m2u(p0, $completion);
};
protoOf(ILocalSource$put$ref).h9 = function (p1, $completion) {
  return this.i6x(p1 instanceof AIImporterStatus ? p1 : THROW_CCE(), $completion);
};
function ILocalSource$put$ref_0($boundThis) {
  var i = new ILocalSource$put$ref($boundThis);
  var l = function (p0, $completion) {
    return i.i6x(p0, $completion);
  };
  l.callableName = 'put';
  l.$arity = 1;
  return l;
}
function AIImporterRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.r6x_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(AIImporterRepository$cacheStrategy$slambda).s6x = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(AIImporterRepository$cacheStrategy$slambda).ma = function ($completion) {
  return this.s6x($completion);
};
protoOf(AIImporterRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.r6x_1.t6x_1.w6x(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(AIImporterRepository$cacheStrategy$slambda).m32 = function (completion) {
  return new AIImporterRepository$cacheStrategy$slambda(this.r6x_1, completion);
};
function AIImporterRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new AIImporterRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.s6x($completion);
  };
  l.$arity = 0;
  return l;
}
function AIImporterRepository$cacheStrategy$lambda(it) {
  return toDomain(it);
}
function AIImporterRepository(remoteSource, localSource) {
  this.t6x_1 = remoteSource;
  this.u6x_1 = localSource;
  var tmp = this;
  var tmp_0 = this.u6x_1.n18();
  var tmp_1 = ILocalSource$put$ref_0(this.u6x_1);
  var tmp_2 = AIImporterRepository$cacheStrategy$slambda_0(this, null);
  tmp.v6x_1 = new SimpleValueEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, AIImporterRepository$cacheStrategy$lambda);
}
function AccountActivationRepository(remoteSource, sessionDataProvider, localSource) {
  this.x6x_1 = remoteSource;
  this.y6x_1 = sessionDataProvider;
  this.z6x_1 = localSource;
}
function ILocalSource$put$ref_1($boundThis) {
  this.a6y_1 = $boundThis;
}
protoOf(ILocalSource$put$ref_1).b6y = function (p0, $completion) {
  return this.a6y_1.m2u(p0, $completion);
};
protoOf(ILocalSource$put$ref_1).h9 = function (p1, $completion) {
  return this.b6y(p1 instanceof EarnedWageAccessDiscovery ? p1 : THROW_CCE(), $completion);
};
function ILocalSource$put$ref_2($boundThis) {
  var i = new ILocalSource$put$ref_1($boundThis);
  var l = function (p0, $completion) {
    return i.b6y(p0, $completion);
  };
  l.callableName = 'put';
  l.$arity = 1;
  return l;
}
function EarnedWageAccessDiscoveryRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.k6y_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(EarnedWageAccessDiscoveryRepository$cacheStrategy$slambda).l6y = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(EarnedWageAccessDiscoveryRepository$cacheStrategy$slambda).ma = function ($completion) {
  return this.l6y($completion);
};
protoOf(EarnedWageAccessDiscoveryRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.k6y_1.n6y_1.p6y(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(EarnedWageAccessDiscoveryRepository$cacheStrategy$slambda).m32 = function (completion) {
  return new EarnedWageAccessDiscoveryRepository$cacheStrategy$slambda(this.k6y_1, completion);
};
function EarnedWageAccessDiscoveryRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new EarnedWageAccessDiscoveryRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function ($completion) {
    return i.l6y($completion);
  };
  l.$arity = 0;
  return l;
}
function EarnedWageAccessDiscoveryRepository$cacheStrategy$lambda(it) {
  return toDomain_1(it);
}
function EarnedWageAccessDiscoveryRepository(localSource, remoteSource) {
  this.m6y_1 = localSource;
  this.n6y_1 = remoteSource;
  var tmp = this;
  var tmp_0 = this.m6y_1.n18();
  var tmp_1 = ILocalSource$put$ref_2(this.m6y_1);
  var tmp_2 = EarnedWageAccessDiscoveryRepository$cacheStrategy$slambda_0(this, null);
  tmp.o6y_1 = new SimpleValueEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, EarnedWageAccessDiscoveryRepository$cacheStrategy$lambda);
}
function KnockToJoinRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.y6y_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(KnockToJoinRepository$cacheStrategy$slambda).b6z = function (_unused_var__etf5q3, data, $completion) {
  var tmp = this.c6z(_unused_var__etf5q3, data, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(KnockToJoinRepository$cacheStrategy$slambda).i9 = function (p1, p2, $completion) {
  var tmp = p1 instanceof KnockToJoinSignupStatus ? p1 : THROW_CCE();
  return this.b6z(tmp, (!(p2 == null) ? isInterface(p2, KtList) : false) ? p2 : THROW_CCE(), $completion);
};
protoOf(KnockToJoinRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.y6y_1.e6z_1.m2u(this.a6z_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(KnockToJoinRepository$cacheStrategy$slambda).c6z = function (_unused_var__etf5q3, data, completion) {
  var i = new KnockToJoinRepository$cacheStrategy$slambda(this.y6y_1, completion);
  i.z6y_1 = _unused_var__etf5q3;
  i.a6z_1 = data;
  return i;
};
function KnockToJoinRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new KnockToJoinRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function (_unused_var__etf5q3, data, $completion) {
    return i.b6z(_unused_var__etf5q3, data, $completion);
  };
  l.$arity = 2;
  return l;
}
function KnockToJoinRepository$cacheStrategy$slambda_1(this$0, resultContinuation) {
  this.o6z_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(KnockToJoinRepository$cacheStrategy$slambda_1).q6z = function (filter, $completion) {
  var tmp = this.r6z(filter, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(KnockToJoinRepository$cacheStrategy$slambda_1).h9 = function (p1, $completion) {
  return this.q6z(p1 instanceof KnockToJoinSignupStatus ? p1 : THROW_CCE(), $completion);
};
protoOf(KnockToJoinRepository$cacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.o6z_1.d6z_1.s6z(toApi(this.p6z_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(KnockToJoinRepository$cacheStrategy$slambda_1).r6z = function (filter, completion) {
  var i = new KnockToJoinRepository$cacheStrategy$slambda_1(this.o6z_1, completion);
  i.p6z_1 = filter;
  return i;
};
function KnockToJoinRepository$cacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new KnockToJoinRepository$cacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function (filter, $completion) {
    return i.q6z(filter, $completion);
  };
  l.$arity = 1;
  return l;
}
function KnockToJoinRepository$cacheStrategy$lambda() {
  return KnockToJoinSignupStatus_PENDING_APPROVAL_getInstance();
}
function KnockToJoinRepository$cacheStrategy$lambda_0(it) {
  return toDomain_2(it);
}
function KnockToJoinRepository$cacheStrategy$lambda_1($this$QueryListEndpointCacheStrategy) {
  return $this$QueryListEndpointCacheStrategy.t6z_1;
}
function KnockToJoinRepository(remoteSource, localSource) {
  this.d6z_1 = remoteSource;
  this.e6z_1 = localSource;
  var tmp = this;
  var tmp0_localDataFlow = this.e6z_1.n18();
  var tmp_0 = KnockToJoinRepository$cacheStrategy$slambda_0(this, null);
  var tmp_1 = KnockToJoinRepository$cacheStrategy$slambda_2(this, null);
  var tmp_2 = KnockToJoinRepository$cacheStrategy$lambda;
  var tmp_3 = KnockToJoinRepository$cacheStrategy$lambda_0;
  tmp.f6z_1 = new QueryListEndpointCacheStrategy(tmp0_localDataFlow, tmp_0, tmp_1, tmp_2, tmp_3, KnockToJoinRepository$cacheStrategy$lambda_1);
}
function IAIImporterRemoteSource() {
}
function basePath($this, $completion) {
  var tmp = new $basePathCOROUTINE$9($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function Companion_4() {
  Companion_instance_6 = this;
  this.i70_1 = ApiVersion_FEBRUARY_2026_getInstance();
}
var Companion_instance_6;
function Companion_getInstance_7() {
  if (Companion_instance_6 == null)
    new Companion_4();
  return Companion_instance_6;
}
function AIImporterRemoteSource$get$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function AIImporterRemoteSource$get$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getCOROUTINE$6(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.r70_1 = _this__u8e3s4;
}
protoOf($getCOROUTINE$6).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          var tmp_0 = this;
          tmp_0.s70_1 = this.r70_1.l72_1;
          this.n8_1 = 1;
          suspendResult = basePath(this.r70_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.t70_1 = suspendResult;
          this.u70_1 = this.t70_1 + '/status';
          var tmp_1 = this;
          tmp_1.v70_1 = Companion_getInstance_7().i70_1;
          this.w70_1 = this.s70_1;
          this.x70_1 = this.u70_1;
          this.y70_1 = this.v70_1;
          var tmp_2 = this;
          tmp_2.z70_1 = AIImporterRemoteSource$get$lambda;
          this.o8_1 = 3;
          var tmp_3 = this;
          tmp_3.b71_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.c71_1 = this.w70_1.f6l_1;
          var tmp_5 = this;
          tmp_5.d71_1 = buildV2Path(this.w70_1, this.x70_1);
          this.e71_1 = this.c71_1;
          this.f71_1 = this.d71_1;
          var tmp_6 = this;
          tmp_6.g71_1 = this.e71_1;
          this.h71_1 = this.g71_1;
          var tmp_7 = this;
          tmp_7.i71_1 = this.h71_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.f71_1);
          headers(this_0, AIImporterRemoteSource$get$lambda_0(this.y70_1));
          this_0.z5n(this.z70_1);
          tmp_8.j71_1 = this_0;
          this.k71_1 = this.i71_1;
          this.l71_1 = this.j71_1;
          this.l71_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_9 = this;
          tmp_9.m71_1 = this.k71_1;
          var tmp_10 = this;
          tmp_10.n71_1 = this.l71_1;
          this.o71_1 = this.m71_1;
          this.p71_1 = this.n71_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.p71_1, this.o71_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.q71_1 = suspendResult;
          var tmp_11 = this;
          this.b71_1;
          var value = this.q71_1;
          tmp_11.a71_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.r71_1 = this.q8_1;
            var tmp_13 = this;
            throw this.r71_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.s71_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.s71_1;
              tmp_15.a71_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.t71_1 = this.a71_1;
          this.u71_1 = this.t71_1;
          this.v71_1 = Result__exceptionOrNull_impl_p6xea9(this.u71_1);
          if (this.v71_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.u71_1);
            tmp_16.x71_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.y71_1 = this.x71_1;
            var tmp_18 = this;
            tmp_18.z71_1 = this.y71_1;
            this.a72_1 = this.z71_1;
            this.b72_1 = this.a72_1.c4u().z43_1;
            var containsArg = this.b72_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_19 = this;
              tmp_19.e72_1 = Companion_instance;
              if (getKClass(ApiAIImporterStatus).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.g72_1 = this.a72_1;
                this.h72_1 = this.g72_1;
                this.n8_1 = 7;
                var tmp_21 = this.h72_1.y4u();
                var tmp_22 = getKClass(ApiAIImporterStatus);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(ApiAIImporterStatus), arrayOf([]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.i72_1 = this.a72_1;
                this.j72_1 = this.i72_1;
                this.n8_1 = 6;
                var tmp_26 = this.j72_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.k72_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.a72_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.v71_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_31.w71_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.k72_1;
          tmp_32.c72_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiAIImporterStatus), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.f72_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_36 = this;
          tmp_36.f72_1 = suspendResult instanceof ApiAIImporterStatus ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.f72_1;
          var tmp_37 = this;
          this.e72_1;
          tmp_37.d72_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.d72_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_42 = this;
          var this_2 = this.d72_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.c72_1 = tmp_43.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.w71_1 = new Result(this.c72_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          return this.w71_1;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function $basePathCOROUTINE$9(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.h70_1 = _this__u8e3s4;
}
protoOf($basePathCOROUTINE$9).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.h70_1.m72_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          var ARGUMENT_0 = ARGUMENT.toString();
          return 'company/' + ARGUMENT_0 + '/ai_importer';
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function AIImporterRemoteSource(apiClient, sessionDataProvider) {
  Companion_getInstance_7();
  this.l72_1 = apiClient;
  this.m72_1 = sessionDataProvider;
}
protoOf(AIImporterRemoteSource).w6x = function ($completion) {
  var tmp = new $getCOROUTINE$6(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function AccountActivationRemoteSource(apiClient) {
  this.n72_1 = apiClient;
}
function IEarnedWageAccessDiscoveryRemoteSource() {
}
function EarnedWageAccessDiscoveryRemoteSource$fetch$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function EarnedWageAccessDiscoveryRemoteSource$fetch$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $fetchCOROUTINE$11(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.w72_1 = _this__u8e3s4;
}
protoOf($fetchCOROUTINE$11).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 14;
          this.n8_1 = 1;
          suspendResult = this.w72_1.s74_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.x72_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.w72_1.s74_1.f2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.y72_1 = suspendResult;
          var tmp_0 = this;
          tmp_0.z72_1 = this.w72_1.r74_1;
          var tmp_1 = this;
          tmp_1.a73_1 = 'company/' + this.x72_1.toString() + '/user/' + this.y72_1.toString() + '/earned_wage_access_discovery';
          var tmp_2 = this;
          tmp_2.b73_1 = ApiVersion_FEBRUARY_2026_getInstance();
          this.c73_1 = this.z72_1;
          this.d73_1 = this.a73_1;
          this.e73_1 = this.b73_1;
          var tmp_3 = this;
          tmp_3.f73_1 = EarnedWageAccessDiscoveryRemoteSource$fetch$lambda;
          this.o8_1 = 4;
          var tmp_4 = this;
          tmp_4.h73_1 = Companion_instance;
          var tmp_5 = this;
          tmp_5.i73_1 = this.c73_1.f6l_1;
          var tmp_6 = this;
          tmp_6.j73_1 = buildV2Path(this.c73_1, this.d73_1);
          this.k73_1 = this.i73_1;
          this.l73_1 = this.j73_1;
          var tmp_7 = this;
          tmp_7.m73_1 = this.k73_1;
          this.n73_1 = this.m73_1;
          var tmp_8 = this;
          tmp_8.o73_1 = this.n73_1;
          var tmp_9 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.l73_1);
          headers(this_0, EarnedWageAccessDiscoveryRemoteSource$fetch$lambda_0(this.e73_1));
          this_0.z5n(this.f73_1);
          tmp_9.p73_1 = this_0;
          this.q73_1 = this.o73_1;
          this.r73_1 = this.p73_1;
          this.r73_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_10 = this;
          tmp_10.s73_1 = this.q73_1;
          var tmp_11 = this;
          tmp_11.t73_1 = this.r73_1;
          this.u73_1 = this.s73_1;
          this.v73_1 = this.t73_1;
          this.n8_1 = 3;
          suspendResult = (new HttpStatement(this.v73_1, this.u73_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.w73_1 = suspendResult;
          var tmp_12 = this;
          this.h73_1;
          var value = this.w73_1;
          tmp_12.g73_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 14;
          this.n8_1 = 5;
          continue $sm;
        case 4:
          this.o8_1 = 14;
          var tmp_13 = this.q8_1;
          if (tmp_13 instanceof CancellationException) {
            this.x73_1 = this.q8_1;
            var tmp_14 = this;
            throw this.x73_1;
          } else {
            var tmp_15 = this.q8_1;
            if (tmp_15 instanceof Error) {
              this.y73_1 = this.q8_1;
              var tmp_16 = this;
              var exception = this.y73_1;
              tmp_16.g73_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 5;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 5:
          this.o8_1 = 14;
          this.z73_1 = this.g73_1;
          this.a74_1 = this.z73_1;
          this.b74_1 = Result__exceptionOrNull_impl_p6xea9(this.a74_1);
          if (this.b74_1 == null) {
            var tmp_17 = this;
            var tmp_18 = _Result___get_value__impl__bjfvqg(this.a74_1);
            tmp_17.d74_1 = (tmp_18 == null ? true : !(tmp_18 == null)) ? tmp_18 : THROW_CCE();
            this.e74_1 = this.d74_1;
            var tmp_19 = this;
            tmp_19.f74_1 = this.e74_1;
            this.g74_1 = this.f74_1;
            this.h74_1 = this.g74_1.c4u().z43_1;
            var containsArg = this.h74_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 10;
              var tmp_20 = this;
              tmp_20.k74_1 = Companion_instance;
              if (getKClass(ApiEarnedWageAccessDiscoveryData).equals(getKClass(Unit))) {
                var tmp_21 = this;
                tmp_21.m74_1 = this.g74_1;
                this.n74_1 = this.m74_1;
                this.n8_1 = 8;
                var tmp_22 = this.n74_1.y4u();
                var tmp_23 = getKClass(ApiEarnedWageAccessDiscoveryData);
                var tmp_24;
                try {
                  tmp_24 = createKType(getKClass(ApiEarnedWageAccessDiscoveryData), arrayOf([]), false);
                } catch ($p) {
                  var tmp_25;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_25 = null;
                  } else {
                    throw $p;
                  }
                  tmp_24 = tmp_25;
                }
                suspendResult = tmp_22.a4u(new TypeInfo(tmp_23, tmp_24), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_26 = this;
                tmp_26.o74_1 = this.g74_1;
                this.p74_1 = this.o74_1;
                this.n8_1 = 7;
                var tmp_27 = this.p74_1.y4u();
                var tmp_28 = getKClass(JsonElement);
                var tmp_29;
                try {
                  tmp_29 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_30;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_30 = null;
                  } else {
                    throw $p;
                  }
                  tmp_29 = tmp_30;
                }
                suspendResult = tmp_27.a4u(new TypeInfo(tmp_28, tmp_29), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_31 = this;
              tmp_31.q74_1 = Companion_instance;
              this.n8_1 = 6;
              suspendResult = mapApiErrorResponse(this.g74_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_32 = this;
            var it = this.b74_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_32.c74_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 13;
            continue $sm;
          }

        case 6:
          var tmp4 = suspendResult;
          var tmp_33 = this;
          this.q74_1;
          tmp_33.i74_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 12;
          continue $sm;
        case 7:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_34 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiEarnedWageAccessDiscoveryData), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_35;
            if (tmp2 instanceof JsonObject) {
              tmp_35 = tmp2.c3p('data');
            } else {
              tmp_35 = false;
            }
            if (tmp_35) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_36;
              if (dataValue instanceof JsonObject) {
                tmp_36 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_36 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_36 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_36;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_34.l74_1 = tmp$ret$0;
          this.n8_1 = 9;
          continue $sm;
        case 8:
          var tmp_37 = this;
          tmp_37.l74_1 = suspendResult instanceof ApiEarnedWageAccessDiscoveryData ? suspendResult : THROW_CCE();
          this.n8_1 = 9;
          continue $sm;
        case 9:
          var tmp1 = this.l74_1;
          var tmp_38 = this;
          this.k74_1;
          tmp_38.j74_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 14;
          this.n8_1 = 11;
          continue $sm;
        case 10:
          this.o8_1 = 14;
          var tmp_39 = this.q8_1;
          if (tmp_39 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_40 = this;
            throw e_0;
          } else {
            var tmp_41 = this.q8_1;
            if (tmp_41 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_42 = this;
              tmp_42.j74_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 11;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 11:
          this.o8_1 = 14;
          var tmp_43 = this;
          var this_2 = this.j74_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_44;
          if (exception_1 == null) {
            var tmp_45 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_45 == null ? true : !(tmp_45 == null)) ? tmp_45 : THROW_CCE();
            tmp_44 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_44 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_43.i74_1 = tmp_44.ul_1;
          this.n8_1 = 12;
          continue $sm;
        case 12:
          this.c74_1 = new Result(this.i74_1);
          this.n8_1 = 13;
          continue $sm;
        case 13:
          return this.c74_1;
        case 14:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 14) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function EarnedWageAccessDiscoveryRemoteSource(apiClient, sessionDataProvider) {
  this.r74_1 = apiClient;
  this.s74_1 = sessionDataProvider;
}
protoOf(EarnedWageAccessDiscoveryRemoteSource).p6y = function ($completion) {
  var tmp = new $fetchCOROUTINE$11(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function IAccountActivationRemoteSource() {
}
function IKnockToJoinRemoteSource() {
}
function KnockToJoinRemoteSource$list$slambda$lambda($status) {
  return function ($this$exhaustiveGet, it) {
    $this$exhaustiveGet.o44_1.r3q('status', $status);
    return Unit_instance;
  };
}
function KnockToJoinRemoteSource$list$slambda$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function KnockToJoinRemoteSource$list$slambda$lambda_1($cursor, $itemsPerPage, $block) {
  return function ($this$url, it) {
    var tmp0_safe_receiver = $cursor._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$url.o44_1.r3q('cursor', tmp0_safe_receiver);
    }
    $this$url.o44_1.r3q('limit', $itemsPerPage.toString());
    $block($this$url, $this$url);
    return Unit_instance;
  };
}
function basePath_0($this, $completion) {
  var tmp = new $basePathCOROUTINE$15($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function Companion_5() {
  Companion_instance_7 = this;
  this.c75_1 = ApiVersion_FEBRUARY_2026_getInstance();
}
var Companion_instance_7;
function Companion_getInstance_8() {
  if (Companion_instance_7 == null)
    new Companion_5();
  return Companion_instance_7;
}
function KnockToJoinRemoteSource$list$slambda(this$0, $status, resultContinuation) {
  this.l75_1 = this$0;
  this.m75_1 = $status;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(KnockToJoinRemoteSource$list$slambda).l77 = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(KnockToJoinRemoteSource$list$slambda).ma = function ($completion) {
  return this.l77($completion);
};
protoOf(KnockToJoinRemoteSource$list$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 18;
          var tmp_0 = this;
          tmp_0.n75_1 = this.l75_1.m77_1;
          this.n8_1 = 1;
          suspendResult = basePath_0(this.l75_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.o75_1 = suspendResult;
          this.p75_1 = this.o75_1 + '/signups';
          var tmp_1 = this;
          tmp_1.q75_1 = Companion_getInstance_8().c75_1;
          var tmp_2 = this;
          tmp_2.r75_1 = KnockToJoinRemoteSource$list$slambda$lambda(this.m75_1);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.t75_1 = this.n75_1;
          this.u75_1 = this.p75_1;
          this.v75_1 = this.q75_1;
          this.w75_1 = this.r75_1;
          var tmp_3 = this;
          tmp_3.x75_1 = 100;
          this.y75_1 = {_v: null};
          var tmp_4 = this;
          tmp_4.z75_1 = ArrayList_init_$Create$();
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.o8_1 = 5;
          var tmp_5 = this;
          tmp_5.b76_1 = Companion_instance;
          var tmp_6 = this;
          tmp_6.c76_1 = this.t75_1.f6l_1;
          var tmp_7 = this;
          tmp_7.d76_1 = buildV2Path(this.t75_1, this.u75_1);
          this.e76_1 = this.c76_1;
          this.f76_1 = this.d76_1;
          var tmp_8 = this;
          tmp_8.g76_1 = this.e76_1;
          this.h76_1 = this.g76_1;
          var tmp_9 = this;
          tmp_9.i76_1 = this.h76_1;
          var tmp_10 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.f76_1);
          headers(this_0, KnockToJoinRemoteSource$list$slambda$lambda_0(this.v75_1));
          this_0.z5n(KnockToJoinRemoteSource$list$slambda$lambda_1(this.y75_1, this.x75_1, this.w75_1));
          tmp_10.j76_1 = this_0;
          this.k76_1 = this.i76_1;
          this.l76_1 = this.j76_1;
          this.l76_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_11 = this;
          tmp_11.m76_1 = this.k76_1;
          var tmp_12 = this;
          tmp_12.n76_1 = this.l76_1;
          this.o76_1 = this.m76_1;
          this.p76_1 = this.n76_1;
          this.n8_1 = 4;
          suspendResult = (new HttpStatement(this.p76_1, this.o76_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          this.q76_1 = suspendResult;
          var tmp_13 = this;
          this.b76_1;
          var value = this.q76_1;
          tmp_13.a76_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 18;
          this.n8_1 = 6;
          continue $sm;
        case 5:
          this.o8_1 = 18;
          var tmp_14 = this.q8_1;
          if (tmp_14 instanceof CancellationException) {
            this.r76_1 = this.q8_1;
            var tmp_15 = this;
            throw this.r76_1;
          } else {
            var tmp_16 = this.q8_1;
            if (tmp_16 instanceof Error) {
              this.s76_1 = this.q8_1;
              var tmp_17 = this;
              var exception = this.s76_1;
              tmp_17.a76_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 6;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 6:
          this.o8_1 = 18;
          this.t76_1 = this.a76_1;
          this.u76_1 = this.t76_1;
          this.v76_1 = Result__exceptionOrNull_impl_p6xea9(this.u76_1);
          if (this.v76_1 == null) {
            var tmp_18 = this;
            var tmp_19 = _Result___get_value__impl__bjfvqg(this.u76_1);
            tmp_18.x76_1 = (tmp_19 == null ? true : !(tmp_19 == null)) ? tmp_19 : THROW_CCE();
            this.y76_1 = this.x76_1;
            var tmp_20 = this;
            tmp_20.z76_1 = this.y76_1;
            this.a77_1 = this.z76_1;
            this.b77_1 = this.a77_1.c4u().z43_1;
            var containsArg = this.b77_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 11;
              var tmp_21 = this;
              tmp_21.e77_1 = Companion_instance;
              if (getKClass(ApiPaginatedResponse).equals(getKClass(Unit))) {
                var tmp_22 = this;
                tmp_22.g77_1 = this.a77_1;
                this.h77_1 = this.g77_1;
                this.n8_1 = 9;
                var tmp_23 = this.h77_1.y4u();
                var tmp_24 = getKClass(ApiPaginatedResponse);
                var tmp_25;
                try {
                  tmp_25 = createKType(getKClass(ApiPaginatedResponse), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiKnockToJoinSignup), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_26;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_26 = null;
                  } else {
                    throw $p;
                  }
                  tmp_25 = tmp_26;
                }
                suspendResult = tmp_23.a4u(new TypeInfo(tmp_24, tmp_25), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_27 = this;
                tmp_27.i77_1 = this.a77_1;
                this.j77_1 = this.i77_1;
                this.n8_1 = 8;
                var tmp_28 = this.j77_1.y4u();
                var tmp_29 = getKClass(JsonElement);
                var tmp_30;
                try {
                  tmp_30 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_31;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_31 = null;
                  } else {
                    throw $p;
                  }
                  tmp_30 = tmp_31;
                }
                suspendResult = tmp_28.a4u(new TypeInfo(tmp_29, tmp_30), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_32 = this;
              tmp_32.k77_1 = Companion_instance;
              this.n8_1 = 7;
              suspendResult = mapApiErrorResponse(this.a77_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_33 = this;
            var it = this.v76_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_33.w76_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 14;
            continue $sm;
          }

        case 7:
          var tmp4 = suspendResult;
          var tmp_34 = this;
          this.k77_1;
          tmp_34.c77_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 13;
          continue $sm;
        case 8:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_35 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiPaginatedResponse), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiKnockToJoinSignup), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_36;
            if (tmp2 instanceof JsonObject) {
              tmp_36 = tmp2.c3p('data');
            } else {
              tmp_36 = false;
            }
            if (tmp_36) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_37;
              if (dataValue instanceof JsonObject) {
                tmp_37 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_37 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_37 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_37;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_35.f77_1 = tmp$ret$0;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          var tmp_38 = this;
          tmp_38.f77_1 = suspendResult instanceof ApiPaginatedResponse ? suspendResult : THROW_CCE();
          this.n8_1 = 10;
          continue $sm;
        case 10:
          var tmp1 = this.f77_1;
          var tmp_39 = this;
          this.e77_1;
          tmp_39.d77_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 18;
          this.n8_1 = 12;
          continue $sm;
        case 11:
          this.o8_1 = 18;
          var tmp_40 = this.q8_1;
          if (tmp_40 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_41 = this;
            throw e_0;
          } else {
            var tmp_42 = this.q8_1;
            if (tmp_42 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_43 = this;
              tmp_43.d77_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 12;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 12:
          this.o8_1 = 18;
          var tmp_44 = this;
          var this_2 = this.d77_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_45;
          if (exception_1 == null) {
            var tmp_46 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_46 == null ? true : !(tmp_46 == null)) ? tmp_46 : THROW_CCE();
            tmp_45 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_45 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_44.c77_1 = tmp_45.ul_1;
          this.n8_1 = 13;
          continue $sm;
        case 13:
          this.w76_1 = new Result(this.c77_1);
          this.n8_1 = 14;
          continue $sm;
        case 14:
          var result = this.w76_1.ul_1;
          var WHEN_RESULT;
          if (_Result___get_isFailure__impl__jpiriv(result)) {
            var tmp_47 = this;
            var tmp0_elvis_lhs = Result__exceptionOrNull_impl_p6xea9(result);
            var exception_3 = tmp0_elvis_lhs == null ? new Unknown() : tmp0_elvis_lhs;
            tmp_47.s75_1 = _Result___init__impl__xyqfz8(createFailure(exception_3));
            this.n8_1 = 17;
            continue $sm;
          } else {
            var tmp_48;
            if (_Result___get_isFailure__impl__jpiriv(result)) {
              tmp_48 = null;
            } else {
              var tmp_49 = _Result___get_value__impl__bjfvqg(result);
              tmp_48 = (tmp_49 == null ? true : !(tmp_49 == null)) ? tmp_49 : THROW_CCE();
            }
            var paginatedResponse = tmp_48;
            var tmp2_safe_receiver = paginatedResponse == null ? null : paginatedResponse.o6m_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.b6m_1;
            this.y75_1._v = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.g6m_1;
            var tmp5_safe_receiver = paginatedResponse == null ? null : paginatedResponse.n6m_1;
            var tmp_50;
            if (tmp5_safe_receiver == null) {
              tmp_50 = null;
            } else {
              tmp_50 = this.z75_1.n(tmp5_safe_receiver);
            }
            WHEN_RESULT = tmp_50;
            this.n8_1 = 15;
            continue $sm;
          }

        case 15:
          if (!(this.y75_1._v == null)) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.n8_1 = 16;
          continue $sm;
        case 16:
          var tmp_51 = this;
          var value_1 = this.z75_1;
          tmp_51.s75_1 = _Result___init__impl__xyqfz8(value_1);
          if (false) {
            this.n8_1 = 2;
            continue $sm;
          }

          this.n8_1 = 17;
          continue $sm;
        case 17:
          return new Result(this.s75_1);
        case 18:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 18) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
protoOf(KnockToJoinRemoteSource$list$slambda).m32 = function (completion) {
  return new KnockToJoinRemoteSource$list$slambda(this.l75_1, this.m75_1, completion);
};
function KnockToJoinRemoteSource$list$slambda_0(this$0, $status, resultContinuation) {
  var i = new KnockToJoinRemoteSource$list$slambda(this$0, $status, resultContinuation);
  var l = function ($completion) {
    return i.l77($completion);
  };
  l.$arity = 0;
  return l;
}
function $basePathCOROUTINE$15(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b75_1 = _this__u8e3s4;
}
protoOf($basePathCOROUTINE$15).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.b75_1.n77_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          var ARGUMENT_0 = ARGUMENT.toString();
          return 'company/' + ARGUMENT_0 + '/knock_to_join';
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function KnockToJoinRemoteSource(apiClient, sessionDataProvider, networkJobManager) {
  Companion_getInstance_8();
  networkJobManager = networkJobManager === VOID ? new NetworkJobManager() : networkJobManager;
  this.m77_1 = apiClient;
  this.n77_1 = sessionDataProvider;
  this.o77_1 = networkJobManager;
}
protoOf(KnockToJoinRemoteSource).s6z = function (status, $completion) {
  var tmp = this.o77_1.n6q(VOID, KnockToJoinRemoteSource$list$slambda_0(this, status, null), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    return tmp;
  return tmp;
};
function get_accountActivationModule() {
  _init_properties_AccountActivationModule_kt__r40y83();
  return accountActivationModule;
}
var accountActivationModule;
function accountActivationModule$lambda($this$module) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp1 = new TypeQualifier(getKClass(EarnedWageAccessDiscovery));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = accountActivationModule$lambda$lambda;
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Singleton_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(ILocalSource), tmp1, definition, kind, secondaryTypes);
  var factory = new SingleInstanceFactory(def);
  $this$module.p1c(factory);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory);
  }
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp5 = new TypeQualifier(getKClass(AIImporterStatus));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = accountActivationModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(ILocalSource), tmp5, definition_0, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp9 = new TypeQualifier(getKClass(ApiDiscoverPayrollMenuItemData));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = accountActivationModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(ILocalSource), tmp9, definition_1, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = accountActivationModule$lambda$lambda_2;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_2 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Factory_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(IAccountActivationRemoteSource), null, tmp2, kind_2, secondaryTypes_2);
  var factory_2 = new FactoryInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = accountActivationModule$lambda$lambda_3;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_3 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Factory_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(IAIImporterRemoteSource), null, tmp2_0, kind_3, secondaryTypes_3);
  var factory_3 = new FactoryInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  new KoinDefinition($this$module, factory_3);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_1 = accountActivationModule$lambda$lambda_4;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_4 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_4 = Kind_Factory_getInstance();
  var secondaryTypes_4 = emptyList();
  var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(IEarnedWageAccessDiscoveryRemoteSource), null, tmp2_1, kind_4, secondaryTypes_4);
  var factory_4 = new FactoryInstanceFactory(def_4);
  $this$module.p1c(factory_4);
  new KoinDefinition($this$module, factory_4);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_2 = accountActivationModule$lambda$lambda_5;
  var scopeQualifier_5 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_5 = Kind_Singleton_getInstance();
  var secondaryTypes_5 = emptyList();
  var def_5 = new BeanDefinition(scopeQualifier_5, getKClass(IAccountActivationRepository), null, definition_2, kind_5, secondaryTypes_5);
  var factory_5 = new SingleInstanceFactory(def_5);
  $this$module.p1c(factory_5);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_5);
  }
  new KoinDefinition($this$module, factory_5);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_3 = accountActivationModule$lambda$lambda_6;
  var scopeQualifier_6 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_6 = Kind_Singleton_getInstance();
  var secondaryTypes_6 = emptyList();
  var def_6 = new BeanDefinition(scopeQualifier_6, getKClass(AIImporterRepository), null, definition_3, kind_6, secondaryTypes_6);
  var factory_6 = new SingleInstanceFactory(def_6);
  $this$module.p1c(factory_6);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_6);
  }
  var tmp = new KoinDefinition($this$module, factory_6);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$32 = [getKClass(IAIImporterAccessor), getKClass(IAIImporterMutator)];
  binds(tmp, tmp$ret$32);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_4 = accountActivationModule$lambda$lambda_7;
  var scopeQualifier_7 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_7 = Kind_Singleton_getInstance();
  var secondaryTypes_7 = emptyList();
  var def_7 = new BeanDefinition(scopeQualifier_7, getKClass(EarnedWageAccessDiscoveryRepository), null, definition_4, kind_7, secondaryTypes_7);
  var factory_7 = new SingleInstanceFactory(def_7);
  $this$module.p1c(factory_7);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_7);
  }
  var tmp_0 = new KoinDefinition($this$module, factory_7);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$38 = [getKClass(IEarnedWageAccessDiscoveryAccessor), getKClass(IEarnedWageAccessDiscoveryMutator)];
  binds(tmp_0, tmp$ret$38);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_5 = accountActivationModule$lambda$lambda_8;
  var scopeQualifier_8 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_8 = Kind_Singleton_getInstance();
  var secondaryTypes_8 = emptyList();
  var def_8 = new BeanDefinition(scopeQualifier_8, getKClass(RefreshAIImporterExtractionStatusUseCase), null, definition_5, kind_8, secondaryTypes_8);
  var factory_8 = new SingleInstanceFactory(def_8);
  $this$module.p1c(factory_8);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_8);
  }
  var tmp_1 = new KoinDefinition($this$module, factory_8);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$44 = [getKClass(IRefreshAIImporterExtractionStatusUseCase)];
  binds(tmp_1, tmp$ret$44);
  return Unit_instance;
}
function accountActivationModule$lambda$lambda($this$single, it) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleCacheLocalSource('earned_wage_access_discovery', tmp$ret$0);
}
function accountActivationModule$lambda$lambda_0($this$single, it) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleCacheLocalSource('ai_importer_status', tmp$ret$0);
}
function accountActivationModule$lambda$lambda_1($this$single, it) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleCacheLocalSource('discover_payroll_menu_item', tmp$ret$0);
}
function accountActivationModule$lambda$lambda_2($this$factory, it) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new AccountActivationRemoteSource(tmp$ret$0);
}
function accountActivationModule$lambda$lambda_3($this$factory, it) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new AIImporterRemoteSource(tmp, tmp$ret$1);
}
function accountActivationModule$lambda$lambda_4($this$factory, it) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new EarnedWageAccessDiscoveryRemoteSource(tmp, tmp$ret$1);
}
function accountActivationModule$lambda$lambda_5($this$single, it) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IAccountActivationRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(ApiDiscoverPayrollMenuItemData));
  var tmp$ret$3 = $this$single.q1d(getKClass(ILocalSource), qualifier, null);
  return new AccountActivationRepository(tmp, tmp_0, tmp$ret$3);
}
function accountActivationModule$lambda$lambda_6($this$single, it) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IAIImporterRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(AIImporterStatus));
  var tmp$ret$2 = $this$single.q1d(getKClass(ILocalSource), qualifier, null);
  return new AIImporterRepository(tmp, tmp$ret$2);
}
function accountActivationModule$lambda$lambda_7($this$single, it) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(EarnedWageAccessDiscovery));
  var tmp = $this$single.q1d(getKClass(ILocalSource), qualifier, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$single.q1d(getKClass(IEarnedWageAccessDiscoveryRemoteSource), null, null);
  return new EarnedWageAccessDiscoveryRepository(tmp, tmp$ret$2);
}
function accountActivationModule$lambda$lambda_8($this$single, it) {
  _init_properties_AccountActivationModule_kt__r40y83();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IAIImporterAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$single.q1d(getKClass(PollingServiceRegistry), null, null);
  return new RefreshAIImporterExtractionStatusUseCase(tmp, tmp$ret$1);
}
var properties_initialized_AccountActivationModule_kt_srelhb;
function _init_properties_AccountActivationModule_kt__r40y83() {
  if (!properties_initialized_AccountActivationModule_kt_srelhb) {
    properties_initialized_AccountActivationModule_kt_srelhb = true;
    accountActivationModule = module_0(VOID, accountActivationModule$lambda);
  }
}
function get_knockToJoinModule() {
  _init_properties_KnockToJoinModule_kt__3yh8yb();
  return knockToJoinModule;
}
var knockToJoinModule;
function knockToJoinModule$lambda($this$module) {
  _init_properties_KnockToJoinModule_kt__3yh8yb();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = knockToJoinModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IKnockToJoinRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp4 = new TypeQualifier(getKClass(KnockToJoinSignup));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = knockToJoinModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IListLocalSource), tmp4, definition, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = knockToJoinModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(KnockToJoinRepository), null, definition_0, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  var tmp = new KoinDefinition($this$module, factory_1);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$13 = [getKClass(IKnockToJoinAccessor), getKClass(IKnockToJoinMutator)];
  binds(tmp, tmp$ret$13);
  return Unit_instance;
}
function knockToJoinModule$lambda$lambda($this$factory, it) {
  _init_properties_KnockToJoinModule_kt__3yh8yb();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new KnockToJoinRemoteSource(tmp, tmp$ret$1);
}
function knockToJoinModule$lambda$lambda_0($this$single, it) {
  _init_properties_KnockToJoinModule_kt__3yh8yb();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('knock_to_join_signups', tmp$ret$0);
}
function knockToJoinModule$lambda$lambda_1($this$single, it) {
  _init_properties_KnockToJoinModule_kt__3yh8yb();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IKnockToJoinRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(KnockToJoinSignup));
  var tmp$ret$2 = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  return new KnockToJoinRepository(tmp, tmp$ret$2);
}
var properties_initialized_KnockToJoinModule_kt_ja0f8r;
function _init_properties_KnockToJoinModule_kt__3yh8yb() {
  if (!properties_initialized_KnockToJoinModule_kt_ja0f8r) {
    properties_initialized_KnockToJoinModule_kt_ja0f8r = true;
    knockToJoinModule = module_0(VOID, knockToJoinModule$lambda);
  }
}
function IAIImporterAccessor() {
}
function IEarnedWageAccessDiscoveryAccessor() {
}
function IKnockToJoinAccessor() {
}
function AIImporterStatus(shiftExtractionStatus, extractedShiftsCount, workflowRunId, hasShiftPromptBeenDismissed) {
  this.p77_1 = shiftExtractionStatus;
  this.q77_1 = extractedShiftsCount;
  this.r77_1 = workflowRunId;
  this.s77_1 = hasShiftPromptBeenDismissed;
}
protoOf(AIImporterStatus).toString = function () {
  return 'AIImporterStatus(shiftExtractionStatus=' + this.p77_1.toString() + ', extractedShiftsCount=' + this.q77_1 + ', workflowRunId=' + this.r77_1 + ', hasShiftPromptBeenDismissed=' + this.s77_1 + ')';
};
protoOf(AIImporterStatus).hashCode = function () {
  var result = this.p77_1.hashCode();
  result = imul(result, 31) + this.q77_1 | 0;
  result = imul(result, 31) + (this.r77_1 == null ? 0 : this.r77_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.s77_1) | 0;
  return result;
};
protoOf(AIImporterStatus).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AIImporterStatus))
    return false;
  var tmp0_other_with_cast = other instanceof AIImporterStatus ? other : THROW_CCE();
  if (!this.p77_1.equals(tmp0_other_with_cast.p77_1))
    return false;
  if (!(this.q77_1 === tmp0_other_with_cast.q77_1))
    return false;
  if (!(this.r77_1 == tmp0_other_with_cast.r77_1))
    return false;
  if (!(this.s77_1 === tmp0_other_with_cast.s77_1))
    return false;
  return true;
};
function EarnedWageAccessDiscovery(shouldShowPrompt) {
  this.t77_1 = shouldShowPrompt;
}
protoOf(EarnedWageAccessDiscovery).toString = function () {
  return 'EarnedWageAccessDiscovery(shouldShowPrompt=' + this.t77_1 + ')';
};
protoOf(EarnedWageAccessDiscovery).hashCode = function () {
  return getBooleanHashCode(this.t77_1);
};
protoOf(EarnedWageAccessDiscovery).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EarnedWageAccessDiscovery))
    return false;
  var tmp0_other_with_cast = other instanceof EarnedWageAccessDiscovery ? other : THROW_CCE();
  if (!(this.t77_1 === tmp0_other_with_cast.t77_1))
    return false;
  return true;
};
function KnockToJoinSignup(id, email, firstName, lastName, expiresSoon, daysUntilExpiry) {
  this.t6z_1 = id;
  this.u6z_1 = email;
  this.v6z_1 = firstName;
  this.w6z_1 = lastName;
  this.x6z_1 = expiresSoon;
  this.y6z_1 = daysUntilExpiry;
}
protoOf(KnockToJoinSignup).toString = function () {
  return 'KnockToJoinSignup(id=' + this.t6z_1 + ', email=' + this.u6z_1 + ', firstName=' + this.v6z_1 + ', lastName=' + this.w6z_1 + ', expiresSoon=' + this.x6z_1 + ', daysUntilExpiry=' + this.y6z_1 + ')';
};
protoOf(KnockToJoinSignup).hashCode = function () {
  var result = getStringHashCode(this.t6z_1);
  result = imul(result, 31) + getStringHashCode(this.u6z_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.v6z_1) | 0;
  result = imul(result, 31) + (this.w6z_1 == null ? 0 : getStringHashCode(this.w6z_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.x6z_1) | 0;
  result = imul(result, 31) + this.y6z_1 | 0;
  return result;
};
protoOf(KnockToJoinSignup).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof KnockToJoinSignup))
    return false;
  var tmp0_other_with_cast = other instanceof KnockToJoinSignup ? other : THROW_CCE();
  if (!(this.t6z_1 === tmp0_other_with_cast.t6z_1))
    return false;
  if (!(this.u6z_1 === tmp0_other_with_cast.u6z_1))
    return false;
  if (!(this.v6z_1 === tmp0_other_with_cast.v6z_1))
    return false;
  if (!(this.w6z_1 == tmp0_other_with_cast.w6z_1))
    return false;
  if (!(this.x6z_1 === tmp0_other_with_cast.x6z_1))
    return false;
  if (!(this.y6z_1 === tmp0_other_with_cast.y6z_1))
    return false;
  return true;
};
var KnockToJoinSignupStatus_PENDING_APPROVAL_instance;
var KnockToJoinSignupStatus_entriesInitialized;
function KnockToJoinSignupStatus_initEntries() {
  if (KnockToJoinSignupStatus_entriesInitialized)
    return Unit_instance;
  KnockToJoinSignupStatus_entriesInitialized = true;
  KnockToJoinSignupStatus_PENDING_APPROVAL_instance = new KnockToJoinSignupStatus('PENDING_APPROVAL', 0);
}
function KnockToJoinSignupStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function KnockToJoinSignupStatus_PENDING_APPROVAL_getInstance() {
  KnockToJoinSignupStatus_initEntries();
  return KnockToJoinSignupStatus_PENDING_APPROVAL_instance;
}
var ShiftExtractionStatus_NOT_STARTED_instance;
var ShiftExtractionStatus_RUNNING_instance;
var ShiftExtractionStatus_COMPLETED_instance;
var ShiftExtractionStatus_SKIPPED_instance;
var ShiftExtractionStatus_FAILED_instance;
var ShiftExtractionStatus_entriesInitialized;
function ShiftExtractionStatus_initEntries() {
  if (ShiftExtractionStatus_entriesInitialized)
    return Unit_instance;
  ShiftExtractionStatus_entriesInitialized = true;
  ShiftExtractionStatus_NOT_STARTED_instance = new ShiftExtractionStatus('NOT_STARTED', 0);
  ShiftExtractionStatus_RUNNING_instance = new ShiftExtractionStatus('RUNNING', 1);
  ShiftExtractionStatus_COMPLETED_instance = new ShiftExtractionStatus('COMPLETED', 2);
  ShiftExtractionStatus_SKIPPED_instance = new ShiftExtractionStatus('SKIPPED', 3);
  ShiftExtractionStatus_FAILED_instance = new ShiftExtractionStatus('FAILED', 4);
}
function ShiftExtractionStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ShiftExtractionStatus_NOT_STARTED_getInstance() {
  ShiftExtractionStatus_initEntries();
  return ShiftExtractionStatus_NOT_STARTED_instance;
}
function ShiftExtractionStatus_RUNNING_getInstance() {
  ShiftExtractionStatus_initEntries();
  return ShiftExtractionStatus_RUNNING_instance;
}
function ShiftExtractionStatus_COMPLETED_getInstance() {
  ShiftExtractionStatus_initEntries();
  return ShiftExtractionStatus_COMPLETED_instance;
}
function ShiftExtractionStatus_SKIPPED_getInstance() {
  ShiftExtractionStatus_initEntries();
  return ShiftExtractionStatus_SKIPPED_instance;
}
function ShiftExtractionStatus_FAILED_getInstance() {
  ShiftExtractionStatus_initEntries();
  return ShiftExtractionStatus_FAILED_instance;
}
function IAIImporterMutator() {
}
function IEarnedWageAccessDiscoveryMutator() {
}
function IKnockToJoinMutator() {
}
function IAccountActivationRepository() {
}
function IRefreshAIImporterExtractionStatusUseCase() {
}
function RefreshAIImporterExtractionStatusUseCase(accessor, pollingServiceRegistry, refreshIntervalMillis, timeoutMillis) {
  refreshIntervalMillis = refreshIntervalMillis === VOID ? new Long(20000, 0) : refreshIntervalMillis;
  timeoutMillis = timeoutMillis === VOID ? new Long(600000, 0) : timeoutMillis;
  this.u77_1 = accessor;
  this.v77_1 = pollingServiceRegistry;
  this.w77_1 = refreshIntervalMillis;
  this.x77_1 = timeoutMillis;
  this.y77_1 = Mutex();
  this.z77_1 = null;
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf($serializer_0).qz = typeParametersSerializers;
protoOf($serializer_1).qz = typeParametersSerializers;
protoOf($serializer_2).qz = typeParametersSerializers;
protoOf($serializer_3).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_2 = new Companion_0();
Companion_instance_3 = new Companion_1();
Companion_instance_4 = new Companion_2();
//endregion
//region block: exports
export {
  get_accountActivationModule as get_accountActivationModule34ya4ftgnq2m4,
  get_knockToJoinModule as get_knockToJoinModule1fzdt45tmzkke,
  IAIImporterAccessor as IAIImporterAccessor1m62b9z97dole,
  IEarnedWageAccessDiscoveryAccessor as IEarnedWageAccessDiscoveryAccessor3mjlvw9qbn6qs,
  IKnockToJoinAccessor as IKnockToJoinAccessor18lz687awqgh1,
  IAIImporterMutator as IAIImporterMutator36oqdhse10f4m,
  IEarnedWageAccessDiscoveryMutator as IEarnedWageAccessDiscoveryMutator17ztrinvi7qwc,
  IKnockToJoinMutator as IKnockToJoinMutator2x4rhmt524y0w,
  IAccountActivationRepository as IAccountActivationRepository1daxwyq2bgwj3,
  IRefreshAIImporterExtractionStatusUseCase as IRefreshAIImporterExtractionStatusUseCase2zq3m42dneye8,
};
//endregion

